import { render } from "./businessCardMember.vue?vue&type=template&id=33866f2f"
import script from "./businessCardMember.vue?vue&type=script&lang=js"
export * from "./businessCardMember.vue?vue&type=script&lang=js"

import "./businessCardMember.vue?vue&type=style&index=0&id=33866f2f&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__